import { Point } from "mapbox-gl";
import React from "react";

type MapArcPathProps = {
  start: Point;
  end: Point;
  gradientId: string;
  strokeWidth?: number;
};

export const MapArcPath: React.FC<MapArcPathProps> = ({
  start,
  end,
  gradientId,
  strokeWidth = 2.5,
}) => {
  const midX = (start.x + end.x) / 2;
  const midY = (start.y + end.y) / 2 - 50; // Control point slightly above

  const pathData = `M${start.x},${start.y} Q${midX},${midY} ${end.x},${end.y}`;

  return (
    <path
      d={pathData}
      stroke={`url(#${gradientId})`}
      strokeWidth={strokeWidth}
      fill="none"
    />
  );
};
